    //   Desktop Menu
    (function ($) { // Begin jQuery

      $(function () { // DOM ready

        $('.testimonials-slider').slick({
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          autoplay: true,
          pauseOnHover: true,
          autoplaySpeed: 10000,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.agents-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          speed: 500,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.agent-stories-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          speed: 500,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }]
        });

        $('.passion-stories-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          speed: 500,
          dots: true,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.belief-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          autoplay: true,
          pauseOnHover: true,
          autoplaySpeed: 10000,
          speed: 500,
          dots: true,
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.featured-list-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          autoplay: true,
          pauseOnHover: true,
          autoplaySpeed: 10000,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          speed: 500,
          dots: true,
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.our-people-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          // centerMode: true,
          mobileFirst: true,
          autoplay: true,
          pauseOnHover: true,
          autoplaySpeed: 10000,
          speed: 500,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right mobile-only"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.programs-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          speed: 500,
          arrows: false,
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        //custom buttons for programs slider

        $('.programs-prev').click(function (e) {
          //e.preventDefault(); 
          $('.programs-slider').slick('slickPrev');
        });

        $('.programs-next').click(function (e) {
          //e.preventDefault(); 
          $('.programs-slider').slick('slickNext');
        });

        
        //custom buttons for beliefs slider

        $('.belief-prev').click(function (e) {
          //e.preventDefault(); 
          $('.belief-slider').slick('slickPrev');
        });

        $('.belief-next').click(function (e) {
          //e.preventDefault(); 
          $('.belief-slider').slick('slickNext');
        });

        $('.blogs-slider').slick({
          slidesToShow: 1,
          infinite: true,
          slidesToScroll: 1,
          mobileFirst: true,
          speed: 500,
          dots: true,
          prevArrow: '<button type="button" class="prev slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Previous</span></button>',
          nextArrow: '<button type="button" class="next slick-arrow"><span class="icon"><svg aria-hidden="true" aria-role="img" class="icon-chevron-right"><use xlink:href="/fonts/icons.svg#icon-chevron-right"></use></svg></span><span class="visually-hidden">Next</span></button>',
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
      }); // end DOM ready
    })(jQuery); // end jQuery